import React, { FunctionComponent } from 'react'
import { IUpdatePercentualTransferenciaMotorista } from '../../domain/usecases/UpdatePercentualTransferenciaMotorista'
import { IGetPercentualTransferenciaMotorista } from '../../domain/usecases/GetPercentualTransferenciaMotorista'
import ContainerPage from '../../../../shared/components/ContainerPage'
import PorcentagemTrasferencias from '../components/PorcentagemTransferencia'
import CartaoNew from '../components/CartaoNew'

interface PorcemtagemTransferencia {
  updatePercentualTransferenciaMotorista: IUpdatePercentualTransferenciaMotorista
  getPercentualTransferenciaMotorista: IGetPercentualTransferenciaMotorista
}
const PorcentagemTransferencia: FunctionComponent<PorcemtagemTransferencia> = ({
  updatePercentualTransferenciaMotorista,
  getPercentualTransferenciaMotorista,
}) => {
  return (
    <ContainerPage
      breadCrumb="Pagamentos/% de Transferência"
      showScaffold={false}
      showFooterScaffold={false}
      header={<CartaoNew />}
    >
      <PorcentagemTrasferencias
        updatePercentualTransferenciaMotorista={
          updatePercentualTransferenciaMotorista
        }
        getPercentualTransferenciaMotorista={
          getPercentualTransferenciaMotorista
        }
      />
    </ContainerPage>
  )
}

export default PorcentagemTransferencia
